import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "./MainHeader";
import NavigationBar from "./NavigationBar";
import NotificationMessage from "./NotificationMessage";
import { getAdsectiondetails } from "redux/actions";
import { getLocalStorageValue } from 'config/helper';
import { useGoogleTagManager } from 'hooks/useGoogleTagManager';

const Header = () => {

  const dispatch = useDispatch();

  useGoogleTagManager();

  const adsSectionData = useSelector(({ adsection }) => adsection.adsData);

  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");

  useEffect(() => {
    const body = {
      ClientStoreId: +storeId || 1,
      RSAClientId: clientId,
    };
    adsSectionData && !adsSectionData.length && dispatch(getAdsectiondetails(body));
  }, [dispatch]); // eslint-disable-line
  
  return (
    <>
      <NotificationMessage />
      {/* 2024-03-08 Rao and valente email <TopHeader /> */}
      <MainHeader />
      <NavigationBar />
    </>
  );
};

export default Header;
